// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__taOJB","description":"About_description__mt2SZ"};